import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

export interface KeycloakTokenResponse {
    access_token: string;
    refresh_token: string;
    expires_in: number;
    token_type: string;
}

@Injectable({
    providedIn: 'root'
})
export class KeycloakTokenService {

    constructor(private http: HttpClient) {
    }

    refreshToken(refreshToken: string): Observable<KeycloakTokenResponse> {
        const body = new HttpParams()
            .set('grant_type', 'refresh_token')
            .set('client_id', environment.keycloak.clientId)
            .set('refresh_token', refreshToken);

        const headers = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded');

        return this.http.post<KeycloakTokenResponse>(
            environment.keycloak.tokenEndpoint,
            body.toString(),
            {headers}
        );
    }
}
